import type { PropsWithChildren } from 'react'

export const FocusedLayoutMain = ({ children }: PropsWithChildren) => {
  return <main className="w-full flex flex-col">{children}</main>
}
